export function initProductLoadMore() {
  const btn = document.querySelector('.btn-load-more-products');
  const grid = document.querySelector('.products-grid');

  if (!btn || !grid) return;

  const getCount = () => window.innerWidth < 768 ? 2 : 8;
  let isLoading = false;

  btn.addEventListener('click', () => {
    if (isLoading) return;
    isLoading = true;

    const offset = parseInt(btn.dataset.offset, 10);
    const count = getCount();

    btn.classList.add('is-loading');

    const formData = new FormData();
    formData.append('action', 'serawai_load_more_products');
    formData.append('nonce', serawai_ajax.nonce);
    formData.append('offset', offset);
    formData.append('count', count);

    fetch(serawai_ajax.url, {
      method: 'POST',
      body: formData,
    })
      .then(res => res.json())
      .then(data => {
        if (data.success && data.data.html) {
          grid.insertAdjacentHTML('beforeend', data.data.html);
          btn.dataset.offset = offset + count;

          if (!data.data.has_more) {
            btn.closest('.btn-wrap').classList.add('is-hidden');
          }
        }
      })
      .catch(() => {
        // Silently fail
      })
      .finally(() => {
        btn.classList.remove('is-loading');
        isLoading = false;
      });
  });
}
